import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface LeavePageStates {
  isModalOpen: boolean;
  isClickedDashboard: boolean;
  navigatingValue: string | number | undefined;
  previousPageUrl: string | undefined;
}

const initialState: LeavePageStates = {
  isModalOpen: false,
  isClickedDashboard: false,
  navigatingValue: undefined,
  previousPageUrl: undefined,
};

const LeavePageSlice = createSlice({
  name: "Leave Page Slice",
  initialState,
  reducers: {
    setLeavePageModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isModalOpen = action.payload;
    },
    setIsClickedDashboard: (state, action: PayloadAction<boolean>) => {
      state.isClickedDashboard = action.payload;
    },
    setNavigatingValue: (
      state,
      action: PayloadAction<string | number | undefined>
    ) => {
      state.navigatingValue = action.payload;
    },
    setPreviousPageUrl: (state, action: PayloadAction<string | undefined>) => {
      state.previousPageUrl = action.payload;
    },
  },
  extraReducers: {},
});

export const { setLeavePageModalOpen, setIsClickedDashboard, setNavigatingValue, setPreviousPageUrl } =
  LeavePageSlice.actions;

export default LeavePageSlice.reducer;
